import React from "react";
import Search from "../components/Search/Search";
import { useLocation } from "react-router-dom";

export default function SearchPage() {
  const location = useLocation();

  return <Search search={location.state} data-testid="search-component" />;
}
